import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledConditionBox = styled.div.withConfig({
  displayName: "ConditionBox__StyledConditionBox",
  componentId: "sc-18hycvq-0"
})(({
  theme,
  size,
  useOnePanel,
  showBorderBox,
  withError,
  isNestedOrHeader
}) => {
  let conditionPadding = undefined;
  let backgroundColor = undefined;
  if (showBorderBox) {
    conditionPadding = theme.space[300];
  } else if (size === 'sm') {
    conditionPadding = `6px ${theme.space[250]}`;
  } else if (size === 'xs') {
    conditionPadding = '5px 0';
  }
  if (useOnePanel) {
    if (isNestedOrHeader) {
      backgroundColor = 'transparent !important';
    } else {
      backgroundColor = theme.color['fill-surface-recessed'];
    }
  } else {
    backgroundColor = theme.color['fill-surface-default'];
  }
  return {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor,
    borderWidth: showBorderBox ? theme.borderWidth[100] : undefined,
    borderStyle: 'solid',
    borderColor: withError ? theme.color['border-alert-default'] : theme.color['border-core-hover'],
    borderRadius: useOnePanel ? theme.borderRadius[300] : theme.borderRadius[100],
    outline: withError && !useOnePanel ? `1px solid ${theme.color['border-alert-default']}` : undefined,
    padding: conditionPadding
  };
});
const ConditionBox = props => {
  const {
    children,
    size = 'md',
    hasError,
    isRefinement = false,
    isNestedOrHeader = false
  } = props;
  const {
    props: {
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized classname is selected by ancestor style rules
    _jsx(StyledConditionBox, {
      className: "condition-box",
      size: size,
      useOnePanel: !!useOnePanel,
      showBorderBox: !isRefinement,
      withError: !!hasError,
      isNestedOrHeader: isNestedOrHeader,
      children: children
    })
  );
};
export default ConditionBox;